import styled from 'styled-components';

export const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
`;
